import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '常熟市金标气门咀有限公司'
          }
        },
        {
          path: '/CompanyIntroduction',
          name: 'CompanyIntroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司简介'
          }
        },
        {
          path: '/ProductCenter',
          name: 'ProductCenter',
          component: resolve => require(['@/view/ProductCenter'], resolve),
          meta: {
            title: '产品中心'
          }
        },
        {
          path: '/NewsInformation',
          name: 'NewsInformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻资讯'
          }
        },
        {
          path: '/ContactUs',
          name: 'ContactUs',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },

        {
          path: '/NewsInfo',
          name: 'NewsInfo',
          component: resolve => require(['@/view/NewsInfo'], resolve),
          meta: {
            title: '新闻详情'
          }
        },
        {
          path: '/ProductInfo',
          name: 'ProductInfo',
          component: resolve => require(['@/view/ProductInfo'], resolve),
          meta: {
            title: '产品详情'
          }
        }

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js